<template>
<div class="field">
    <label class="label">Send suggestions to email</label>
    <div class="control has-icons-left">
        <span class="icon is-small is-left">
            <FaIcon icon="envelope"/>
        </span>
        <input
            :value="value"
            @input="$emit('input', $event.target.value)"
            class="input"
            type="email"/>
    </div>
    <p class="help">
        You'll receive emails from guanzo91@gmail.com.
        To unsubscribe, delete the above email and click save.
    </p>
</div>
</template>

<script>
export default {
    name: 'ConfigEmail',
    props: {
        value: String
    },
}
</script>
